import { isNil } from 'lodash';
import moment from 'moment';
import { INFINITY } from './constants';

export const NO_VISIT = 'No Visit';

export const VISIT_STATUS = {
  ACTIVE: 'active',
  WARNING: 'warning',
  SKIPPING: 'skipping',
  NA: 'n/a',
};

export interface IPatientVisitInfoType {
  visitStatus: string;
  numberOfDaysSinceLastVisit: Nullable<number>;
  daysSinceLastVisitSortKey: Nullable<number | string>;
}

export const getVisitStatus = (daysSinceLastSeen: Nullable<number>): string => {
  if (isNil(daysSinceLastSeen)) return VISIT_STATUS.SKIPPING;
  if (daysSinceLastSeen >= 0 && daysSinceLastSeen < 20) {
    return VISIT_STATUS.ACTIVE;
  }
  if (daysSinceLastSeen >= 20 && daysSinceLastSeen <= 30) {
    return VISIT_STATUS.WARNING;
  }
  return VISIT_STATUS.SKIPPING;
};

const visitInfoForNoVisit = (
  rxStartDate: Nullable<string>,
): IPatientVisitInfoType => {
  const daysAgo = moment().diff(rxStartDate || undefined, 'days');
  return {
    visitStatus: getVisitStatus(daysAgo),
    numberOfDaysSinceLastVisit: null,
    daysSinceLastVisitSortKey: -1,
  };
};

const visitInfoForComplianceNotActive = (): IPatientVisitInfoType => ({
  visitStatus: VISIT_STATUS.NA,
  numberOfDaysSinceLastVisit: null,
  daysSinceLastVisitSortKey: INFINITY,
});

const visitStatusForVisit = (
  daysSinceClinicVisit: Nullable<number | string>,
): IPatientVisitInfoType => {
  const daysLookup: { [key: string]: any } = {
    string: parseInt,
    object: () => null,
    number: Number,
  };
  const numberOfDaysSinceLastVisit =
    daysLookup[typeof daysSinceClinicVisit](daysSinceClinicVisit);
  return {
    // @ts-ignore
    visitStatus: getVisitStatus(daysSinceClinicVisit),
    numberOfDaysSinceLastVisit,
    daysSinceLastVisitSortKey: daysSinceClinicVisit,
  };
};

export const visitInfo = (
  daysRemaining: Nullable<number>,
  daysSinceClinicVisit: Nullable<number | string>,
  startDate: Nullable<string>,
): IPatientVisitInfoType => {
  if (!daysRemaining) return visitInfoForComplianceNotActive();
  if (daysSinceClinicVisit === NO_VISIT) return visitInfoForNoVisit(startDate);
  return visitStatusForVisit(daysSinceClinicVisit);
};
